import { fetchDataAPI } from '../helpers/fetchDataAPI';
import { URL_BASE_API } from './glogal';
import { store } from '../store'


export const login = (username, password) => {
    const url = `${URL_BASE_API}/api/auth/login`;
    const language = store.getState().configuration.language;
    const rsp = fetchDataAPI(url, {
        field01: username,
        field02: password,
        lang: language
    });
    
    return rsp;
}


export const loginWithGoogle = (objectAuthenticated) => {
    const url = `${URL_BASE_API}/api/auth/loginwithgoogle`;
    const language = store.getState().configuration.language;
    const rsp = fetchDataAPI(url, {
        field01: objectAuthenticated,
        lang: language
    });
    
    return rsp;
}

export const renewSession = (userId) => {
    const url = `${URL_BASE_API}/api/auth/getNewToken`;
    const language = store.getState().configuration.language;
    const token = store.getState().userLogged.token;
    const config = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    };

    const rsp = fetchDataAPI(
        url, 
        {
            field01: userId,
            lang: language
        }, 
        config);
    
    return rsp;
}

export const passwordRecovery_IsValidAccount = (email) => {
    const url = `${URL_BASE_API}/api/security/IsValidAccount`;
    const language = store.getState().configuration.language;

    const rsp = fetchDataAPI(url, {
        field01: email,
        lang: language
    });

    return rsp;
}


export const passwordRecovery_ResendCode = (email) => {
    const url = `${URL_BASE_API}/api/security/resendverificationcode`;
    const language = store.getState().configuration.language;
    
    const rsp = fetchDataAPI(url, {
        field01: email,
        lang: language
    });
    
    return rsp;
}


export const passwordRecovery_CodeValidation = (email, code) => {
    const url = `${URL_BASE_API}/api/security/codevalidation`;
    const language = store.getState().configuration.language;
    
    const rsp = fetchDataAPI(url, {
        field01: email,
        field02: code,
        lang: language
    });
    
    return rsp;
}


export const passwordRecovery_SetNewPassword = (email, code, newPassword) => {
    const url = `${URL_BASE_API}/api/security/setnewpassword`;
    const language = store.getState().configuration.language;
    
    const rsp = fetchDataAPI(url, {
        field01: email,
        field02: code,
        field03: newPassword,
        lang: language
    });
    
    return rsp;
}

